import { defineMessages } from 'react-intl';

export const purchaseOrderEmptyStateMessages = defineMessages({
  emptyStateHeader: {
    id: 'h3ajV/',
    defaultMessage: 'Streamline Your Inventory with Purchase Orders',
    description: 'Header text for purchase order feature gate empty state',
  },
  emptyStateDescription: {
    id: 'GtNRp3',
    defaultMessage:
      'Purchase orders help you manage inventory restocking by creating order requests to suppliers. Track expected delivery dates, manage vendors, and ensure you never run out of your best-selling products.',
    description: 'Description text explaining purchase order benefits',
  },
  emptyStateSubDescription: {
    id: 'CbNytj',
    defaultMessage:
      'With purchase orders, you can maintain optimal inventory levels, reduce stockouts, and improve your supply chain efficiency.',
    description: 'Additional description text for purchase order benefits',
  },
  upgradeToAccess: {
    id: 'wpXm0j',
    defaultMessage: 'Upgrade your plan to access Purchase Orders',
    description: 'Promotional banner header for purchase order upgrade',
  },
  unlockFeature: {
    id: 'YDayM2',
    defaultMessage: 'Unlock advanced inventory management tools to grow your business',
    description: 'Promotional banner subheader for purchase order upgrade',
  },
  upgradeNow: {
    id: 'SQhUhj',
    defaultMessage: 'Upgrade Now',
    description: 'Button text for upgrading to access purchase orders',
  },
});
